import { useContext, useState } from "react";
import { login } from "../models/login";
import { UserContextType, useAuth } from "../auth/";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useLocation, useNavigate } from "react-router-dom";

const Login: React.FC = () => {
  const { login } = useContext<UserContextType>(useAuth);
  const navigate = useNavigate();
  const location = useLocation();
  // Set by pages that redirect here when sign-in is required (e.g. a group setup link).
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo;
  const [loginInfo, setLoginInfo] = useState<login>({
    email: "",
    password: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (event: any) => {
    event.preventDefault();
    if (login) {
      setIsSubmitting(true);
      try {
        await login(loginInfo, returnTo);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const onUserNameChange = (event: any) => {
    setLoginInfo((login) => {
      return {
        ...login,
        email: event.target.value,
      };
    });
  };

  const onPasswordChange = (event: any) => {
    setLoginInfo((login) => {
      return {
        ...login,
        password: event.target.value,
      };
    });
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          boxShadow: 3,
          borderRadius: 2,
          px: 4,
          py: 6,
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",
        }}
      >
        <Typography component="h1" variant="h4" gutterBottom>
          Sign in
        </Typography>
        <Box component="form" onSubmit={onSubmit} noValidate sx={{ mt: 1, width: "100%" }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={onUserNameChange}
            disabled={isSubmitting}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={onPasswordChange}
            disabled={isSubmitting}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing In..." : "Sign In"}
          </Button>
          <Grid container>
            <Grid item xs>
              <Link
                href="#"
                variant="body2"
                onClick={() => navigate("/forgot-password")}
              >
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link
                variant="body2"
                onClick={() => navigate("/register")}
                sx={{ cursor: 'pointer' }}
              >
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
